export default "__VITE_ASSET__DJryWAtm__"